import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Icon from '../Icon/Icon';
import CopyContent from '../common/CopyContent';
import DomainDisclaimer from './DomainDisclaimer';

const DomainsTutorial = ({ type, parkingType }) => {
  return (
    <div className="domains-tutorial">
      <div className="domains-tutorial--header">
        <h3 className="domains-tutorial--title">
          <FormattedMessage id="domains.tutorial.title" defaultMessage="Domain parking guide" />
        </h3>
        {/* <Button
          size="md"
          color="primary"
          tag="a"
          href="/faq/videoinstruction/parking"
          target="_blank"
        >
          <Icon type="play" />
          <FormattedMessage id="domains.tutorial.video_link" defaultMessage="Video guide" />
        </Button> */}
      </div>
      <div className="domains-tutorial--body">
        <p className="domains-tutorial--intro">
          <FormattedMessage
            values={{ steps: 4 }}
            id="domains.tutorial.intro"
            defaultMessage="To park domain in OFFERRUM you need to perform a simple setup in your domain registrator office."
          />
        </p>
        <ul className="domains-tutorial--steps list-unstyled">
          <li className="domains-tutorial--step">
            <FormattedMessage
              id="domains.tutorial.step.1"
              defaultMessage="1. Buy a domain and setup the following NS records in registrator panel:"
            />
            <br />
            <span id="domain-tutorial--ns1" className="domains-tutorial--link">
              ns1.mrrffo.com&nbsp;
            </span>
            <CopyContent
              delay={500}
              content="ns1.mrrffo.com"
              iconType="copy-2"
              copyMessageId="main"
              tooltipMessageId="main.copy"
              tooltipTargetId="domain-tutorial--ns1"
            />
            <br />
            <span id="domain-tutorial--ns2" className="domains-tutorial--link">
              ns2.mrrffo.com&nbsp;
            </span>
            <CopyContent
              delay={500}
              content="ns2.mrrffo.com"
              iconType="copy-2"
              copyMessageId="main"
              tooltipMessageId="main.copy"
              tooltipTargetId="domain-tutorial--ns2"
            />
            <p className="domains-tutorial--small">
              <FormattedMessage
                id="domains.tutorial.step.1.disclaimer"
                defaultMessage="Wait for the changes to take effect. This process can last up to 72 hours, usually 60 minutes."
              />
            </p>
          </li>
          <li className="domains-tutorial--step">
            <FormattedMessage
              values={{ stepID: 2 }}
              id="domains.tutorial.step.2"
              defaultMessage="2. Choose parking domain type;"
            />{' '}
          </li>
          <li className="domains-tutorial--step">
            <FormattedMessage
              values={{ stepID: 3 }}
              id="domains.tutorial.step.3"
              defaultMessage="3. Past your domain's URL and press the Add domain button;"
            />
          </li>
        </ul>
      </div>

      <DomainDisclaimer type={type} />
    </div>
  );
};

export default DomainsTutorial;
